import moment from 'moment';
import { ALARM_NULL_END_DATE } from '@kentik/ui-shared/alerting/constants';
import { isAlarmActive } from '@kentik/ui-shared/synthetics/utils';
import { formatDurationPrecise } from 'app/stores/alerting/timeUtils';

/*
  How long an alarm has been in effect, as {elapsedMs, isActive, end}, or null where that has no
  answer. end is the resolved end time, and is null while the alarm is still active.

  Alert manager reports a missing end either by omitting the field or by sending the
  ALARM_NULL_END_DATE sentinel; an active alarm has no meaningful end so it is measured against
  now, and a cleared alarm with no end has no measurable span at all rather than a guessed one.
*/
export function alarmElapsed({ startTime, endTime, state }) {
  const isActive = isAlarmActive(state);
  const end = endTime && endTime !== ALARM_NULL_END_DATE ? endTime : null;

  if (!startTime || (!isActive && !end)) {
    return null;
  }

  const start = moment.utc(startTime);
  const finish = isActive ? moment.utc() : moment.utc(end);

  if (!start.isValid() || !finish.isValid()) {
    return null;
  }

  const elapsedMs = finish.diff(start);

  if (!Number.isFinite(elapsedMs) || elapsedMs < 0) {
    return null;
  }

  return { elapsedMs, isActive, end: isActive ? null : end };
}

// only the two most significant units, which keeps the value readable at a glance
export function formatAlarmElapsed(elapsed) {
  return elapsed ? formatDurationPrecise(elapsed.elapsedMs, 2) : null;
}
